import { Box, CircularProgress, Typography } from '@mui/material'
import { FC } from 'react'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

interface LoadingIndicatorProps {
  message?: string
  size?: number
}

export const LoadingIndicator: FC<LoadingIndicatorProps> = ({
  message = '読み込み中...',
  size = 40,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      p: 4,
    }}
  >
    <CircularProgress size={size} sx={{ color: colorTokens.fg.muted }} />
    <Typography
      sx={{
        color: colorTokens.fg.default,
      }}
    >
      {message}
    </Typography>
  </Box>
)
